module.exports = __webpack_public_path__ + "imgs/facebook-white.191de4fd74de52ae7e4ecbc03d33eef8.svg";